export const GET_ZKEY_MAPPING = `/api/BeachSwap/GetAllBeachSwapMappings`;
export const DOWNLOAD_ZKEY_MAPPINGS = `api/BeachSwap/DownloadBeachSwapMappingExcel`;
export const ADD_UPDATE_ZKEY_MAPPING = `/api/BeachSwap/AddOrUpdateBeachSwapMapping`;
export const DELETE_TERMINAL_MAPPINGS = `/api/BeachSwap/DeleteBeachSwapMapping`;
export const GET_ZKEY_MAPPING_AUDIT_LOGS = `api/BeachSwap/GetBeachSwapMappingAuditLog`;
export const GET_BEACH_SWAPS = `/api/BeachSwap/GetBeachSwaps`;
export const ADD_UPDATE_BEACH_SWAP = `/api/BeachSwap/AddorUpdateBeachSwap`;
export const GET_BEACH_SWAP_BY_ID = `/api/BeachSwap/GetBeachSwapById`;
export const GET_BEACH_SWAP_LOGS = `/api/BeachSwap/GetBeachSwapLogs`;
export const DOWNLOAD_BEACHSWAP_NOMINATIONS = `/api/BeachSwap/DownloadBeachSwapsExcel`;
export const DELETE_BEACH_SWAPS = `/api/BeachSwap/DeleteBeachSwap`;
export const UPLOAD_TO_ENDUR_BEACH_SWAP = `/api/BeachSwap/UploadToEndur`;
export const GET_BEACH_SWAP_PAYLOAD_INFO = `/api/BeachSwap/GetBeachSwapPayloadInfo`;
export const BULK_UPDATE = '/api/BeachSwap/BulkUpdate';

export const radioButtonOptions = ['KWh', 'Therms'];
export const ALIGNE_ACTIONS = ['Submitted'];

export const MESSAGES = {
  SERVER_ERROR: 'Something went wrong please contact system administrator.',
  REQUIRED_QUANTITY: 'Quantity is required',
  REQUIRED_LOCATION: 'Location is required',
  REQUIRED_Z_KEY: 'zKey is required',
  REQUIRED_SWAP_TYPE: 'Swap Type is required',
  REQUIRED_DEAL_LEG_ID: 'Deal ID is required',
  REQUIRED_UNIT: 'Unit is required',
  REQUIRED_COUNTER_PARTY: 'Counter Party is required',
  REQUIRED_DATE_TYPE: 'Date Type is required',
  REQUIRED_TERMINAL: 'Terminal is required',
  REQUIRED_SUB_TERMINAL: 'SubTerminal is required',
  REQUIRED_VALID_FROM: 'Valid From is required',
  REQUIRED_VALID_TO: 'Valid To is required',
  REQUIRED_GAS_DAY: 'Gas Day is required',
  REQUIRED_BUY_SELL: 'Buy/Sell is required',
  REQUIRED_PRIMARY_SECONDARY: 'Primary/Secondary is required',
  REQUIRED_DEAL_UNIT: 'Deal Unit is required',
  INVALID_DEAL_LEG_ID:
    'Deal ID format is invalid. It should be in the format digits_digits (e.g. 123_4)',
  INVALID_NBP_DEAL_LEG_ID:
    'NBP Deal ID format is invalid. It should be in the format digits_digits (e.g. 123_4)',
  REQUIRED_NBP_DEAL_LEG_ID: 'NBP Deal ID is required',
  NBP_SAME_AS_DEAL: 'NBP Deal ID must not be the same as Deal ID',
  INVALID_VALIDITY_RANGE: 'Valid From must be on or before Valid To',
};

export const CONFIRM_ENUM = {
  NOT_VALIDATED: 6,
  VALIDATED: 7,
  AMENDED: 8,
  NOT_CONFIRMED: 9,
  CONFIRMED: 10,
  CONFIRM_AMENDED: 11,
};

export const ENDUR_STATUS_MAP: Record<number, string> = {
  1: 'New',
  2: 'InQueue',
  3: 'Success',
  4: 'Failed',
  5: 'Sent',
};

export const VALIDATION_STATUS_MAP = {
  VALIDATED: 1,
  NOT_VALIDATED: 2,
  AMENDED: 3,
};

export const CONFIRMATION_STATUS_MAP = {
  CONFIRMED: 1,
  NOT_CONFIRMED: 2,
  AMENDED: 3,
};

export const DEAL_UNIT_ENUM = [
  { id: 'kWh', name: 'kWh' },
  { id: 'Therms', name: 'Therms' },
];
